<div class="how-it-works-modal">
  <fgb-how-it-works [isModal]="true"></fgb-how-it-works>
</div>
